<template>
  <TitledCard :title="$t('advanceCard')">
    <span class="d-block" data-testid="open-advances-count">{{
      $t('openAdvances', { count: openAdvancesCount })
    }}</span>
    <span class="d-block" data-testid="submitted-advances-count">{{
      $t('submittedAdvances', { count: submittedAdvancesCount })
    }}</span>
    <template #actions>
      <v-btn data-testid="create-advance-button" text color="primary" @click="openAdvanceDialog">{{
        $t('newAdvanceButton')
      }}</v-btn>
      <v-btn
        data-testid="show-advances-button"
        text
        :to="{ name: 'advances', params: { id: meeting.id } }"
        color="primary"
        >{{ $t('showAdvancesButton') }}</v-btn
      >
    </template>
    <AdvanceDialog ref="advanceDialog" @update="fetchAdvances" />
  </TitledCard>
</template>
<script>
import { createLink } from '@/api/helpers'
import { api } from '@/api'
import size from 'lodash/size'
import reject from 'lodash/reject'
import filter from 'lodash/filter'

export default {
  name: 'AdvanceCard',
  props: {
    meeting: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      advances: [],
    }
  },
  computed: {
    openAdvancesCount() {
      return size(reject(this.advances, { status: 'SUBMITTED' }))
    },
    submittedAdvancesCount() {
      return size(filter(this.advances, { status: 'SUBMITTED' }))
    },
  },
  mounted() {
    this.fetchAdvances()
  },
  methods: {
    openAdvanceDialog() {
      this.$refs.advanceDialog.openWithMeeting(this.meeting)
    },
    async fetchAdvances() {
      const { data } = await api.get(createLink('meetings/{id}/advances', { id: this.meeting.id }))
      this.advances = data
    },
  },
}
</script>
